import { useActiveOrganizationId, useAuthentication } from "@/contexts"

interface UseUserAccessValue {
  isLimitedAccessUser: boolean | undefined
}

export const useUserAccess = (): UseUserAccessValue => {
  const { activeUser } = useAuthentication()
  const { activeOrganizationId } = useActiveOrganizationId()

  const isLimitedAccessUser: boolean | undefined =
    !activeUser || !activeOrganizationId
      ? undefined
      : activeUser.limitedAccessOrganizationIds.includes(
          Number(activeOrganizationId)
        )

  return {
    isLimitedAccessUser,
  }
}
